export default {
  projectName: '共享云盘'
}
